import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['content'];

  reveal(event) {
    event.currentTarget.remove();
    this.contentTarget.classList.remove('u-displayNone');
  }
}
